import { useState, useEffect, RefObject, KeyboardEventHandler } from 'react';

// Adapted from here: https://bit.dev/doad/doadds/hooks/use-focus-trap/~code#useFocusTrap.js

const useFocusTrap = (ref: RefObject<HTMLElement>): KeyboardEventHandler<HTMLElement> => {
  const [focus, setFocus] = useState(0);
  const [focusableElements, setFocusableElements] = useState<HTMLElement[]>();

  const getKeyboardFocusableElements = (element: HTMLElement) => {
    const focusableElements = Array.from(
      element.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
    );

    return ((focusableElements as unknown) as Array<HTMLElement>).filter(
      (el) => !el.hasAttribute('disabled')
    );
  };

  const handleTabulation: KeyboardEventHandler<HTMLElement> = (e) => {
    if (focusableElements?.length) {
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        setFocus((focus) => (focus + 1) % focusableElements.length);
      }
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        setFocus((focus) => (focus - 1 < 0 ? focusableElements.length - 1 : focus - 1));
      }
    }
  };

  useEffect(() => {
    if (!focusableElements) {
      const elements = ref.current ? getKeyboardFocusableElements(ref.current) : undefined;
      setFocusableElements(elements);
    } else if (focusableElements[focus]) {
      focusableElements[focus].focus();
    }
  }, [focus, focusableElements, ref]);

  return handleTabulation;
};

export default useFocusTrap;
